import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/returns.scss";

const returnSteps = [
  {
    title: "Prepare your request",
    text: "Have your order number and the email address used at checkout ready. Select the pieces you wish to send back and the reason for return.",
  },
  {
    title: "Pack the pieces",
    text: "Place each item, with all original tags and accessories, in the protective packaging. Reuse the shipping carton whenever possible.",
  },
  {
    title: "Apply the label",
    text: "Cover the original carrier label and attach the prepaid return label securely to the outside of the parcel.",
  },
  {
    title: "Hand it to the carrier",
    text: "Use the carrier named on the label and retain the drop-off receipt until your refund has been confirmed.",
  },
];

const eligibilityItems = [
  "Unworn, unused, and unaltered",
  "Returned with original tags and packaging",
  "Footwear tried only on a clean, soft surface",
  "Protective seals intact on eligible accessories",
];

function Returns() {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="returns-page">
      <header className="returns-page__hero">
        <p>Client services</p>
        <h1>Returns and refunds</h1>
        <div>
          <p>
            Online purchases may be returned within 14 days of delivery, subject
            to the conditions below. We want every {siteConfig.brandName} piece
            to feel considered and right for you.
          </p>
          <span>Original condition required</span>
        </div>
      </header>

      <div className="returns-page__layout">
        <aside>
          <nav aria-label="On this page">
            <p>On this page</p>
            <a href="#return-eligibility">Return eligibility</a>
            <a href="#return-process">How to return</a>
            <a href="#return-refunds">Refunds</a>
            <a href="#return-exclusions">Exclusions</a>
            <a href="#return-exchanges">Exchanges</a>
          </nav>
        </aside>

        <article className="returns-page__content">
          <section id="return-eligibility" aria-labelledby="return-eligibility-title">
            <p className="returns-page__index">01</p>
            <h2 id="return-eligibility-title">Return eligibility</h2>
            <p>
              Start your return within 14 calendar days after the recorded delivery
              date. Items are inspected on arrival and must meet every condition
              relevant to the product.
            </p>
            <ul className="returns-page__checklist">
              {eligibilityItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>

          <section id="return-process" aria-labelledby="return-process-title">
            <p className="returns-page__index">02</p>
            <h2 id="return-process-title">How to make a return</h2>
            <ol className="returns-page__steps">
              {returnSteps.map((step, index) => (
                <li key={step.title}>
                  <span aria-hidden="true">0{index + 1}</span>
                  <div>
                    <h3>{step.title}</h3>
                    <p>{step.text}</p>
                  </div>
                </li>
              ))}
            </ol>
            <p className="returns-page__note">
              If your parcel did not include return documents, contact Client
              Services before shipping it independently.
            </p>
          </section>

          <section id="return-refunds" aria-labelledby="return-refunds-title">
            <p className="returns-page__index">03</p>
            <h2 id="return-refunds-title">Refund timing</h2>
            <p>
              Once received, returns are normally inspected within 3-5 business
              days. Approved refunds are issued to the original payment method.
              Your financial institution may require up to 10 additional business
              days to post the credit.
            </p>
            <dl className="returns-page__facts">
              <div>
                <dt>Original delivery fee</dt>
                <dd>Refunded only where required by applicable law.</dd>
              </div>
              <div>
                <dt>Return delivery fee</dt>
                <dd>Any applicable deduction is disclosed before you confirm the return.</dd>
              </div>
              <div>
                <dt>Gift purchases</dt>
                <dd>Refunded to the payment method used by the purchaser.</dd>
              </div>
            </dl>
          </section>

          <section id="return-exclusions" aria-labelledby="return-exclusions-title">
            <p className="returns-page__index">04</p>
            <h2 id="return-exclusions-title">Items that cannot be returned</h2>
            <p>
              Personalized or altered pieces, final-sale products, opened fragrance
              and grooming items, and goods without required hygiene or security
              seals cannot be accepted unless they arrived damaged or incorrect.
            </p>
          </section>

          <section id="return-exchanges" aria-labelledby="return-exchanges-title">
            <p className="returns-page__index">05</p>
            <h2 id="return-exchanges-title">Exchanges and damaged orders</h2>
            <p>
              Direct online exchanges are not currently available. Return the
              original item and place a new order for your preferred size or color.
              If a piece arrives damaged or differs from your order, contact us
              promptly and include clear photographs of the item and packaging.
            </p>
          </section>

          <footer className="returns-page__actions">
            <div>
              <p>Need help with a return?</p>
              <h2>Client Services can review your order.</h2>
            </div>
            <div>
              <Link to="/contact" onClick={toTop}>
                Contact us
              </Link>
              <Link to="/shop" onClick={toTop}>
                Continue shopping
              </Link>
            </div>
          </footer>
        </article>
      </div>
    </main>
  );
}

export default Returns;
